import React from 'react';
import PropTypes from 'prop-types';
import { withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps';

class SubmissionLocationMap extends React.Component {
  render() {
    const bounds = new window.google.maps.LatLngBounds();
    this.props.markers.map(marker => {
      bounds.extend(new window.google.maps.LatLng(
        marker.lat,
        marker.lng
      ));
    });

    return (
      <GoogleMap
        defaultZoom={4}
        onClick={this.props.onClick}
        options={{
          streetViewControl: false,
          mapTypeControl: false,
        }}
        ref={map => map && map.fitBounds(bounds)}
      >
        {this.props.markers && this.props.markers.map(marker => (
          <Marker
            key={marker.answerText}
            position={{ lat: marker.lat, lng: marker.lng }}
          >
            <InfoWindow>
              <div>{marker.answerText}</div>
            </InfoWindow>
          </Marker>
        ))}
      </GoogleMap>
    );
  }
}

SubmissionLocationMap.propTypes = {
  markers: PropTypes.array.isRequired,
  selectedMarker: PropTypes.string,
  onClick: PropTypes.func,
};

export default withGoogleMap(SubmissionLocationMap);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/SubmissionLocationMap.js